export type IndicatorProductSubscriptionDetails = {
  id: string;
  calculation_enabled: boolean;
  use_geomodel_service_for_facts: boolean;
  sync_plots_with_geomodel_service: boolean;
  sync_data_for_plots: boolean;
  count_of_plots_synced: number;
};

export type IndicatorProductDetails = {
  geomodel_geo_model_name: string | null;
  geomodel_git_sha: string | null;
  geomodel_version_number: string | null;
  fact_label_sets: string[];
  indicator_names: string[];
  applicable_land_types: string[];
  applicable_crop_types: string[];
};

export type JobSubscription = {
  id: string;
  org: string;
  job_product: string;
  job_product_display_name: string;
  ndi_plot_portfolio_subscription: string;
  ndi_plot_portfolio_subscription_display_name: string;
  display_name: string;
  start_date: string;
  end_date: string;
  status: string;
  job_creation_cost_credits: number;
  job_execution_cost_credits: number;
  indicator_product_subscription: string | null;
  indicator_product_subscription_details: IndicatorProductSubscriptionDetails | null;
  /** Only present on the single-item GET (retrieve) response, not on list entries. */
  indicator_product_details?: IndicatorProductDetails | null;
  created_at: string;
  modified_at: string;
};

/**
 * GET /api/v1/subscriptions/job-subscriptions/
 */
export const GET_JOB_SUBSCRIPTIONS_PATH = 'subscriptions/job-subscriptions/';
export type GetJobSubscriptionsRequestQueryParams =
  | {
      org?: string;
      limit?: number;
      offset?: number;
    }
  | undefined;
export type GetJobSubscriptionsSuccessDto = {
  count: number;
  next: string | null;
  previous: string | null;
  results: JobSubscription[];
};
export type GetJobSubscriptionsErrorDto = Error;

/**
 * GET /api/v1/subscriptions/job-subscriptions/{id}/
 */
export const GET_JOB_SUBSCRIPTION_BY_ID_PATH = 'subscriptions/job-subscriptions/{id}/';
export type GetJobSubscriptionByIdRequestPathVariables = { id: string };
export type GetJobSubscriptionByIdErrorDto = Error;

/**
 * POST /api/v1/subscriptions/job-subscriptions/
 */
export const POST_JOB_SUBSCRIPTION_PATH = 'subscriptions/job-subscriptions/';
export type PostJobSubscriptionRequestBodyData = {
  org: string;
  job_product: string;
  ndi_plot_portfolio_subscription: string;
  display_name?: string;
  start_date: string;
  end_date: string;
  job_creation_cost_credits?: number;
  job_execution_cost_credits?: number;
};
export type PostJobSubscriptionErrorDto = Error;

/**
 * PATCH /api/v1/subscriptions/job-subscriptions/{id}/
 */
export const PATCH_JOB_SUBSCRIPTION_PATH = 'subscriptions/job-subscriptions/{id}/';
export type PatchJobSubscriptionRequestPathVariables = { id: string };
export type PatchJobSubscriptionRequestBodyData = {
  ndi_plot_portfolio_subscription?: string;
  display_name?: string;
  start_date?: string;
  end_date?: string;
  status?: string;
  job_creation_cost_credits?: number;
  job_execution_cost_credits?: number;
  indicator_product_subscription?: {
    calculation_enabled?: boolean;
    use_geomodel_service_for_facts?: boolean;
    sync_plots_with_geomodel_service?: boolean;
    sync_data_for_plots?: boolean;
  };
};
export type PatchJobSubscriptionErrorDto = Error;
